import React from "react";

/**
 * Catches render errors in a dashboard page so one broken tab shows a message
 * instead of blanking the whole app. Pass `resetKey` (e.g. the URL path) so
 * navigating elsewhere clears the error.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" style={{ maxWidth: 560, margin: "48px auto", padding: 24, textAlign: "center", fontFamily: "inherit" }}>
        <h2 style={{ marginBottom: 8 }}>Something went wrong on this page</h2>
        <p style={{ color: "#4b5563", marginBottom: 16 }}>
          This part of the dashboard couldn't load. Your other tabs still work. Try again, or go back.
        </p>
        <button
          type="button"
          onClick={() => this.setState({ error: null })}
          style={{ marginRight: 8, padding: "8px 16px", cursor: "pointer" }}
        >
          Try again
        </button>
        <button
          type="button"
          onClick={() => window.history.back()}
          style={{ padding: "8px 16px", cursor: "pointer" }}
        >
          Go back
        </button>
      </div>
    );
  }
}
